
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { Scan, ScannerStore, SOFTLINE_FEATURE_SCANNER } from '@softline/application';
import { Store } from '@softline/core';
import { MessageBarService} from '@softline/ui-core';
import { Subscription } from 'rxjs';
import { skip } from 'rxjs/operators';

import { InputComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-esl-code',
  imports: [
    InputComponent,
    TranslatePipe
  ],
  templateUrl: './esl-code.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./esl-code.component.css'] })
export class EslCodeComponent implements OnInit, OnDestroy {
  private subscription?: Subscription;
  readonly #messageBarService = inject(MessageBarService);

  constructor(private store: Store) {}

  @Input() value: string | null = null;

  @Output() submit = new EventEmitter<string | null | undefined>();

  ngOnInit(): void {
    this.subscription = this.store
      .observe(SOFTLINE_FEATURE_SCANNER, ScannerStore.getters.latest)
      .pipe(skip(1))
      .subscribe(async (scan) => {
        await this.validateScan(scan);
      });
  }

  ngOnDestroy() {
    if (this.subscription && !this.subscription.closed) this.subscription.unsubscribe();
    this.subscription = undefined;
  }

  onSubmit(): void {
    this.submit.emit(this.value);
    if (this.subscription && !this.subscription.closed) this.subscription.unsubscribe();
    this.subscription = undefined;
  }

  async startScan(): Promise<void> {
    await this.store.dispatch(SOFTLINE_FEATURE_SCANNER, ScannerStore.actions.scan, {
      labelType: ['code128'] });
  }

  async validateScan(scan: Scan | undefined): Promise<void> {
    switch (scan?.labelType) {
      case 'code128':
        this.submit.emit(scan.data);
        break;
      default:
        this.#messageBarService.error('Codetyp nicht unterstützt');
    }
  }
}
